import React, { useState, useEffect, useRef } from "react";
import {
  CardContent,
  Grid,
  Paper,
  Tabs,
  Tab,
  TextField,
  FormControl,
  CircularProgress,
  Autocomplete,
  DatePicker,
  TabPanel,
  FullscreenDialog,
  Button,
  Tooltip,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "../../../components";
import { AddLayout } from "../../../layouts";
import {
  PessoaService,
  notification,
  PedidosService,
  PedidosItensService,
  MeioPagamentoService,
  ProdutosService,
  OperacaoFiscalService,
  history,
  CondicoesPagamentoService,
  SessionService,
  ColaboradorService,
  OrigemMercadoriaService,
  TabelaVendaService,
  EnderecosEstoqueService,
} from "../../../services";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import {
  responseErros,
  formatDate,
  userLogs,
  voltar,
  verificarBaixaAutomatica,
  montarFiltroPessoa,
} from "../../../utils";
import { pedidosValidator, enderecoValidator } from "./middlewares";
import {
  ButtonMenu,
  PedidosItens,
  PedidosPagamentos,
  PedidosCampos,
  PedidosDadosClientes,
  ComissaoVendedorDialog,
  CampoPersonalizadoDialog,
  ResumoTotal,
} from "./components";
import { useImportContext } from "../../../contexts/import.context";
import AddPessoas from "../../pessoas/addPessoa/addPessoa.view";
import {
  tabProps,
  calcularValorTotal,
  mapearEndereco,
  encontrarEnderecoPadrao,
  compararPagamentosTotalPedidos,
  mapearEnderecos,
  limparCampoTotalizador,
  calcularPrecoProduto,
  formatTotalItemAcrescimo,
  validarTabelaVendaMeioPagamento,
  validarTabelaTodosProdutosMeioPagamento,
  validarTabelaVendaCliente,
} from "./addPedidos";
import { Pedido } from "./entities";
import { format } from "date-fns";
import HistorioClienteDialog from "./components/dialogComponents/historico-cliente-dialog.component";
import shortid from "shortid";

const pedidosService = new PedidosService();
const pessoaService = new PessoaService();
const sessionService = new SessionService();
const colaboradorService = new ColaboradorService();
const meioPagamentoService = new MeioPagamentoService();
const tabelaVendaService = new TabelaVendaService();
const condicoesPagamentoService = new CondicoesPagamentoService();
const produtosService = new ProdutosService();
const operacaoFiscalService = new OperacaoFiscalService();
const pedidosItensService = new PedidosItensService();
const origemMercadoriaService = new OrigemMercadoriaService();
const enderecosEstoqueService = new EnderecosEstoqueService();

let pedidoEntity = {
  dataEmissao: formatDate.toSend(new Date()),
  entrada: 0,
  desconto: 0,
  acrescimo: 0,
  despesas: 0,
  despesasItem: false,
  descontoItem: false,
};

const AddPedidosView = ({ match }) => {
  const documentoImportado = window.location.pathname
    .split("/")
    .pop()
    .includes("importar");
  const id = !documentoImportado && match.params.id;
  const inputCliente = useRef();
  const [loading, setLoading] = useState(true);
  const [userLog, setUserLog] = useState({});
  const dadosEmpresaUsuario = sessionService.getEmpresaAndUsuario();
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
    useState(false);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [loadingAutoCompleteCliente, setLoadingAutoCompleteCliente] =
    useState(false);
  const [loadingAutoCompleteProduto, setLoadingAutoCompleteProduto] =
    useState(false);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const [pedido, setPedido] = useState(pedidoEntity);
  // const prevStateRef = useRef(pedido);
  const { initialCollapses } = useImportContext();
  const [itemValorComissaoVendedor, setItemValorComissaoVendedor] =
    useState(null);
  const [itemPercentualComissaoVendedor, setItemPercentualComissaoVendedor] =
    useState(null);
  const [itemTotalComissaoVendedor, setItemTotalComissaoVendedor] =
    useState(null);
  const [clienteList, setClienteList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [condicaoPagParcelaList, setCondicaoPagParcelaList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [operacaoFiscalList, setOperacaoFiscalList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [permitirVendaEstoqueNegativo, setPermitirVendaEstoqueNegativo] =
    useState(false);
  const [obrigatoriedadeMeioPagamento, setObrigatoriedadeMeioPagamento] =
    useState(false);
  const [produtoList, setProdutoList] = useState([]);
  const [produto, setProduto] = useState(null);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [listaPedidosProdutos, setListaPedidosProdutos] = useState([]);
  const [cidadeId, setCidadeId] = useState(null);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
  });
  const [tabelasTodosProdutos, setTabelasTodosProdutos] = useState([]);
  const [endereco, setEndereco] = useState({
    padrao: false,
  });
  const [enderecoCliente, setEnderecoCliente] = useState(null);
  const [enderecoClienteDataGrid, setEnderecoClienteDataGrid] = useState([]);
  const [enderecoAleterado, setEnderecoAleterado] = useState(null);
  const [listaPedidosPagamentos, setListaPedidosPagamentos] = useState([]);
  const [origensMercadoriasList, setOrigensMercadoriasList] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [gerarPagamentos, setGerarPagamentos] = useState({});
  const [campoPersonalizado, setCampoPersonalizado] = useState({});
  const [openComissaoDialog, setOpenComissaoDialog] = useState(false);
  const [tiposTotalizadoresColumnView, setTiposTotalizadoresColumnView] =
    useState(false);
  const [openCampoPersonalizadoDialog, setOpenCampoPersonalizadoDialog] =
    useState(false);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);
  const [meioPagamentoSelecionado, setMeioPagamentoSelecionado] =
    useState(null);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("pedidos-visualizar");
  const vendedorObrigatorio = permissoesHelper.temPermisao(
    "pedidos-vendedor-obrigatorio",
  );
  const tiposCampo = [
    {
      id: 1,
      type: "date",
      descricao: "Data",
    },
    {
      id: 2,
      type: "number",
      descricao: "Número",
    },
    {
      id: 3,
      type: "string",
      descricao: "Letras e Número",
    },
    {
      id: 4,
      type: "money",
      descricao: "Monetário",
    },
  ];
  const tiposPessoa = [
    {
      tipoId: 1,
      setLista: (dados) => setClienteList(dados),
    },
    {
      tipoId: 4,
      setLista: (dados) => setVendedorList(dados),
    },
  ];

  const buscarConfiguracao = async () => {
    if (dadosEmpresaUsuario.empresa.configuracoes) {
      const data = dadosEmpresaUsuario.empresa.configuracoes;
      setObrigatoriedadeMeioPagamento(data?.obrigatoriedadeMeioPagamento);
      if (data?.obrigatoriedadeMeioPagamento) {
        setAbaValue(1);
      }
      pedidoEntity.setConfiguracoes(data);
      setPedido({ ...pedidoEntity });
      setPermitirVendaEstoqueNegativo(data.vendaEstoqueNegativo);
      if (data.operacaoFiscalVendasPadraoId) {
        await buscarOperacaoFiscal(data.operacaoFiscalVendasPadraoId);
        return true;
      }
    }
  };

  async function buscaDadosIniciais() {
    const listMeiosPagamento = await buscarMeiosPagamento();
    if (!id && !documentoImportado) {
      pedidoEntity = new Pedido({
        dataEmissao: formatDate.toSend(new Date()),
        entrada: 0,
        desconto: 0,
      });
      await buscarPessoaVendedor();
    } else {
      await buscaPedidos(listMeiosPagamento);
    }
    buscarCondicoesPagamento();
    buscarVendedores();
    buscarOrigensMercadoria();
    buscarEnderecosEstoque();
    await buscarTabelasVendaTodosProdutos();
    const operacaoPadrao = await buscarConfiguracao();
    if (!operacaoPadrao) buscarOperacaoFiscal();
    setItemValorComissaoVendedor(null);
    setItemPercentualComissaoVendedor(null);
    setItemTotalComissaoVendedor(null);
  }

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarPessoaVendedor = async (filtros) => {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) =>
          colaborador.usuarioId === dadosEmpresaUsuario.usuario.id,
      );
      if (colaboradorVendedorUsuario) {
        pedidoEntity.setHandleChangeInput(
          "pessoaVendedorId",
          colaboradorVendedorUsuario.pessoa.id,
        );
        pedidoEntity.setVendedorObrigatorioPermissao(vendedorObrigatorio);
        setPedido(pedidoEntity);
      }
    } else {
      responseErros(result);
    }
  };

  useEffect(() => {
    buscaDadosIniciais().then(() => {
      setLoading(false);
    });
  }, []);

  const validarProdutosTabelaVenda = (tabelasVenda = null) => {
    const tabelasVendaProduto = tabelasVenda ?? tabelas;
    const tabelaTodosProdutos = validarTabelaTodosProdutosMeioPagamento(
      tabelasTodosProdutos,
      meioPagamentoSelecionado?.id,
    );

    if (listaPedidosProdutos.length > 0) {
      const produtosAtualizados = listaPedidosProdutos.map((pedidoProduto) => {
        let resultItem = {
          ...pedidoProduto,
          descontoPorcentagem: 0,
          desconto: 0,
          despesas: 0,
        };
        if (
          validarTabelaVendaCliente(
            tabelasVendaProduto?.cliente,
            resultItem.produtoId,
          )
        ) {
          resultItem = calcularPrecoProduto(
            resultItem,
            tabelasVendaProduto?.cliente,
          );
        } else if (tabelasVendaProduto?.grupoPessoa) {
          resultItem = calcularPrecoProduto(
            resultItem,
            tabelasVendaProduto?.grupoPessoa,
          );
        } else if (
          validarTabelaVendaMeioPagamento(
            pedidoProduto?.tabelasVenda,
            meioPagamentoSelecionado?.id,
          )
        ) {
          resultItem = calcularPrecoProduto(
            resultItem,
            resultItem?.tabelasVenda[0] || {},
            "meioPagamento",
          );
        } else if (tabelaTodosProdutos) {
          resultItem = calcularPrecoProduto(resultItem, tabelaTodosProdutos);
          const { totalItem } = formatTotalItemAcrescimo(
            resultItem,
            acrescimoPagamento,
          );
          resultItem.totalItem = totalItem;
        } else {
          const { valorUnitario, totalItem } = formatTotalItemAcrescimo(
            resultItem,
            acrescimoPagamento,
          );
          resultItem.valorUnitario = valorUnitario;
          resultItem.totalItem = totalItem;
          resultItem.desconto = pedidoProduto.desconto;
          resultItem.descontoPorcentagem = pedidoProduto.descontoPorcentagem;
          resultItem.despesas = pedidoProduto.despesas;
        }
        return resultItem;
      });
      pedidoEntity.setChangeItens(produtosAtualizados);
      setPedido(pedidoEntity);
      setListaPedidosProdutos(produtosAtualizados);

      const valorTitulo =
        parseFloat(pedidoEntity?.totalPedido ?? 0) -
        parseFloat(pedidoEntity?.totalPagamentos ?? 0);
      if (valorTitulo > 0) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          valorTitulo,
        }));
      }
    }
  };

  useEffect(() => {
    validarProdutosTabelaVenda();
  }, [meioPagamentoSelecionado]);

  const buscaPedidos = async (listMeiosPagamento = []) => {
    if (id) {
      const result = await pedidosService.getById(id);
      if (!result.isAxiosError) {
        if (!result.data) {
          initialCollapses();
          voltar();
          return;
        }
        pedidoEntity = new Pedido(result.data, id);
        pedidoEntity.initTotalPagamentos();
      } else {
        responseErros(result);
        initialCollapses();
        voltar();
      }
    } else {
      pedidoEntity = window?.pedidoEntity;
    }
    return await inserirDadosPedido(listMeiosPagamento);
  };

  async function inserirDadosPedido(listMeiosPagamento) {
    setPedido(pedidoEntity);
    setListaPedidosPagamentos(pedidoEntity?.pagamentos);
    buscarProdutosAvancado(pedidoEntity?.itens);
    setEnderecoAleterado(pedidoEntity?.pedidoEnderecoCliente);
    buscarDadosClientes(pedidoEntity?.pessoaClienteId, listMeiosPagamento);
  }

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(pedido);
    setUserLog(logs);
  }

  const buscarPessoas = async (filtros, tiposPessoaId) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      limite: 20,
      ativado: true,
    };
    const tipoPessoaTemp = tiposPessoa.find(
      ({ tipoId }) => tipoId === tiposPessoaId,
    );
    pessoaService.getAll(filtro).then((res) => {
      setLoadingAutoCompleteCliente(false);
      if (!res.isAxiosError) {
        tipoPessoaTemp?.setLista(res.data.rows);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 4,
      vendedor: true,
      ativado: true,
      attributes: ["id", "nomeRazaoSocial"],
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarOperacaoFiscal = async (id) => {
    const filtros = {
      ativado: true,
      tipoOperacao: "SAIDA",
      restritiva: true,
      finalidade: ["NAO_SE_APLICA", "NFE_NORMAL"],
      nonPaginated: true,
    };
    operacaoFiscalService.getAllFiltroAvancado(filtros).then((result) => {
      if (!result.isAxiosError) {
        setOperacaoFiscalList(result.data);
        if (!id && result.data.length) {
          const operacaoPadrao = result.data.find(
            (operacao) => operacao.id === id,
          );
          if (operacaoPadrao) {
            pedidoEntity.setOperacaoFiscal(operacaoPadrao);
            setPedido(pedidoEntity);
          }
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDadosClientes = async (clienteId, listMeiosPagamento = []) => {
    if (!clienteId) return;
    pessoaService.getById(clienteId).then((result) => {
      if (!result.isAxiosError) {
        setClienteSelecionado(result.data);
        buscarDocumentosCliente(clienteId);
        filterMeiosPagamentoCliente(
          result.data.clientes[0],
          listMeiosPagamento,
        );
        if (result.data.enderecos?.length)
          adicionarEnderecosCliente(result.data.enderecos);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (pessoaClienteId) => {
    setLoadingHistorico(true);
    pedidosService
      .getAll({ pessoaClienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows.length) {
            setPedidos(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setPedidos([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  async function adicionarEnderecosCliente(enderecos) {
    const enderecoPadrao = encontrarEnderecoPadrao(enderecos);
    if (enderecoPadrao) {
      const enderecoCliente = await mapearEndereco(enderecoPadrao);
      setEnderecoCliente(enderecoCliente);
      pedidoEntity.setEnderecoCliente(null, enderecoCliente);
    }
    const enderecosMapeados = await mapearEnderecos(enderecos);
    setEnderecoClienteDataGrid(enderecosMapeados);
  }

  const buscarMeiosPagamento = async (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    return meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
        return result.data;
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setCondicaoPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarProdutosAvancado = (itens) => {
    const produtosIds = itens.map(({ produtoId }) => produtoId);
    const filtro = {
      id: produtosIds,
      ativado: true,
      nonPaginated: true,
      tabelasVenda: true,
    };
    produtosService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setProdutoList(result.data);
        if (itens && itens.length) {
          preencherItens(itens, result.data);
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarOrigensMercadoria = () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const preencherItens = (itensBusca, produtos) => {
    const itens = itensBusca.map((item) => {
      const produtoBusca = produtos.find(
        (produto) => produto.id == item.produtoId,
      );
      return {
        ...item,
        descricao: produtoBusca?.descricao,
        totalItem: calcularValorTotal(item),
        precoVenda: produtoBusca?.informacao?.precoVenda,
        tabelasVenda: produtoBusca?.tabelasVenda,
      };
    });
    pedidoEntity.setChangeItens(itens);
    setPedido(pedidoEntity);
    setListaPedidosProdutos(itens);
  };

  const buscarProdutosSimilares = async (produtoId) => {
    if (produtoId) {
      produtosService.getById(produtoId).then((result) => {
        if (!result.isAxiosError) {
          setProdutosSimilares(result.data.similares);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const onInputChangeCamposPersonalizados = (event) => {
    setCampoPersonalizado({
      ...campoPersonalizado,
      [event.target.name]: event.target.value,
    });
  };

  const onSearchChangePessoas = (event, tiposPessoaId) => {
    if (
      event.key === "Enter" &&
      inputCliente.current === document.activeElement
    ) {
      const filtros = montarFiltroPessoa(event.target?.value, tiposPessoaId);
      setLoadingAutoCompleteCliente(true);
      buscarPessoas(filtros, tiposPessoaId);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    pedidoEntity.setHandleChangeAutoComplete(name, value);
    setPedido(pedidoEntity);
  };

  const handleChangeInput = (event) => {
    pedidoEntity.setHandleChangeInput(event.target.name, event.target.value);
    setPedido(pedidoEntity);
  };

  const handleAdicionarCampoPersonalizado = () => {
    setCampoPersonalizado({});
    setOpenCampoPersonalizadoDialog(false);
  };

  const buscarProdutosCadastrados = () => {
    const filter = {
      nonPaginated: true,
      pedidoId: id,
    };
    pedidosItensService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        preencherItens(res.data, produtoList);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarTabelasVendaTodosProdutos = async () => {
    const filtros = {
      ativado: true,
      nonPaginated: true,
      restritiva: true,
      tabelaRegente: true,
      tipoTabela: "TODOS_PRODUTOS",
    };
    const response = await tabelaVendaService.getAll(filtros);
    if (!response.isAxiosError) {
      setTabelasTodosProdutos(response.data);
    } else {
      responseErros(response);
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
        tipoTabela: "POR_PRODUTO",
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (
            intGrupoPessoaId &&
            tabela.intGrupoPessoaId === intGrupoPessoaId
          ) {
            acc.grupoPessoa = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null },
      );

      validarProdutosTabelaVenda(tabelasProcessadas);
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseCadastroCliente = () => {
    buscarPessoas();
    setPedido(pedidoEntity);
    setIsCadastroPessoaDialogOpen(false);
  };

  const removerProdutoCadastrado = async (idProduto) => {
    setLoading(true);
    const res = await pedidosItensService.deletarEmLote(idProduto);
    if (!res.isAxiosError) {
      buscarProdutosCadastrados();
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const salvarEndereco = async () => {
    const body = {
      ...endereco,
      cidadeId: cidadeId,
      pessoaId: pedido?.pessoaClienteId,
    };
    enderecoValidator
      .validate(body, { abortEarly: false })
      .then(async () => {
        setLoading(true);
        const res = await pessoaService.cadastrarEndereco(
          pedido?.pessoaClienteId,
          body,
        );
        if (!res.isAxiosError) {
          notification.cadastroSucesso();
          setEnderecoClienteDataGrid([
            ...enderecoClienteDataGrid,
            { ...body, id: shortid.generate() },
          ]);
        } else {
          responseErros(res);
        }
        setLoading(false);
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  async function validarPedidos(indiceSelecionado) {
    const isBaixaAutomatica = verificarBaixaAutomatica(
      listaPedidosPagamentos,
      meioPagamentoList,
    );
    if (!isBaixaAutomatica && !pedido.pessoaClienteId) {
      setLoading(false);
      return notification.alertaGenericos(
        "É necessário informar cliente para vendas a prazo",
      );
    }
    const pagamentosTotalPedidos = compararPagamentosTotalPedidos(pedido);
    if (pagamentosTotalPedidos) {
      setLoading(false);
      setAbaValue(1);
      return notification.alertaGenericos(
        "É necessário atualizar valor da(s) parcela(s)",
      );
    }
    await handleSubmit(indiceSelecionado);
  }

  async function handleSubmit(indiceSelecionado) {
    setLoading(true);
    pedidosValidator
      .validate(pedidoEntity, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await pedidosService.atualizar(id, pedidoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            history.goBack();
          } else {
            buscaPedidos();
            responseErros(response);
          }
        } else {
          const response = await pedidosService.cadastrar(pedidoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              pedidoEntity.setNumeroDocumento(response.data.numeroDocumento);
              const permissaoDeny = permissoesHelper.temPermisao(
                "pedidos-enviar-documento-apos-criacao",
              );
              const props = {
                title: "Documento cadastrado com sucesso",
                text: `#${response.data.numeroDocumento}`,
                icon: "success",
                confirmButtonText: "IMPRIMIR",
                cancelButtonText: permissaoDeny ? "EMAIL" : "FECHAR",
                showCancelButton: true,
                showCloseButton: permissaoDeny,
                closeButtonHtml:
                  "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
                dangerMode: true,
              };
              if (
                permissaoDeny &&
                dadosEmpresaUsuario.empresa?.whatsappSimples
              ) {
                props.width = "min(38rem, calc(100vw - 2rem))";
                props.denyButtonText = "WHATSAPP";
                props.showDenyButton = true;
              }
              const confirmacaoAlerta = await notification.confirmacaoGenericos(
                props,
              );
              if (confirmacaoAlerta.isConfirmed) {
                document.getElementById("botaoMenuAction")?.click();
              } else if (confirmacaoAlerta?.isDenied) {
                setOpenDialogEnvioWhatsapp(true);
              } else if (
                confirmacaoAlerta?.dismiss === "cancel" &&
                permissaoDeny
              ) {
                document.getElementById("botaoEmailAction")?.click();
              } else {
                initialCollapses();
                voltar();
              }
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.message.includes("pagamento")) {
          setAbaValue(1);
        }
        inputErros.set(err);
      });
  }

  const handleCancelar = () => {
    setPedido({
      dataEmissao: formatDate.toSend(new Date()),
      entrada: 0,
      desconto: 0,
    });
    setListaPedidosProdutos([]);
    setListaPedidosPagamentos([]);
  };

  const onClickCancelarPedido = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Cancelar!",
      "Tem certeza que deseja cancelar esse pedido?",
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const response = await pedidosService.cancelar(id);
      setLoading(false);
      if (!response.isAxiosError) {
        notification.alteracaoSucesso();
        history.push("/faturamento/pedidos");
      } else {
        responseErros(response);
      }
    }
  };

  const removerDadosCliente = () => {
    setInputErro([]);
    setEnderecoClienteDataGrid([]);
    setEnderecoCliente(null);
    setEnderecoAleterado(null);
    pedidoEntity.setEnderecoCliente();
  };

  const handleChangeSwitch = (e) => {
    const name = e.target.name;
    if (
      (name === "descontoItem" || name === "despesasItem") &&
      pedidoEntity.itens?.length
    ) {
      const nomeCampo = name.replace("Item", "");
      const listaItensTotalizador = limparCampoTotalizador(
        nomeCampo,
        pedidoEntity.itens,
      );
      pedidoEntity.setChangeItens(listaItensTotalizador);
      setProdutoList([...pedidoEntity.itens]);
      setProduto((prevState) => ({
        ...prevState,
        [nomeCampo]: 0,
      }));
    }
    pedidoEntity.setHandleChangeSwitch(name, e.target.checked);
    setPedido({ ...pedidoEntity });
  };

  const onChangeAutocompleteCliente = (newValue) => {
    removerDadosCliente();
    if (!newValue || (newValue && newValue.id !== clienteSelecionado?.id)) {
      setListaPedidosPagamentos([]);
      pedidoEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: pedido?.totalPedido,
      }));
    }
    pedidoEntity.setHandleChangeAutoComplete("pessoaClienteId", newValue);
    setPedido(pedidoEntity);
    setClienteSelecionado(newValue);
    buscarDadosClientes(newValue?.id);
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
      const sugestaoVendedorId = newValue.clientes[0].sugestaoVendedorId;
      const sugestaoVendedor = vendedorList.filter(
        ({ id }) => id === sugestaoVendedorId,
      );
      if (sugestaoVendedorId && sugestaoVendedor.length > 0) {
        handleChangeAutocomplete("pessoaVendedorId", sugestaoVendedor[0]);
      }
    } else {
      const tabelaVazia = {
        cliente: null,
        grupoPessoa: null,
      };
      setTabelas(tabelaVazia);
      validarProdutosTabelaVenda(tabelaVazia);
      setMeiosPagamentoCliente(null);
    }
  };

  const filterMeiosPagamentoCliente = (cliente, listMeiosPagamento) => {
    const list =
      meioPagamentoList.length > 0 ? meioPagamentoList : listMeiosPagamento;
    if (cliente.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = list?.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === gerarPagamentos?.meioPagamentoId,
      );
      if (gerarPagamentos?.meioPagamentoId && !meioPagamentoValido) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagParcelaList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  return (
    <AddLayout
      id={id}
      title={id ? "Editar pedido" : "Cadastrar pedidos"}
      onClickSalvar={validarPedidos}
      loading={loading}
      codigo={
        id && pedido?.numeroDocumento
          ? `Nº Documento ${pedido?.numeroDocumento}`
          : ""
      }
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      ButtonMenu={
        <ButtonMenu
          id={id}
          data={{
            ...pedido,
            empresa: dadosEmpresaUsuario.empresa,
            usuario: dadosEmpresaUsuario.usuario,
            itens: listaPedidosProdutos,
            pagamentos: listaPedidosPagamentos,
            dataEmissaoFormat: format(
              new Date(Date.parse(pedido.dataEmissao)),
              "dd/MM/yyyy HH:MM",
            ),
            vendedor: pedido?.pessoaVendedorId
              ? value.autoComplete(vendedorList, pedido?.pessoaVendedorId)
                  ?.nomeRazaoSocial
              : null,
            cliente: clienteSelecionado,
            enderecoCliente: enderecoAleterado || enderecoCliente,
            estadoCliente: enderecoCliente?.estado,
            meioPagamentoList,
          }}
          configuracoes={dadosEmpresaUsuario.empresa?.configuracoes}
          onClickCancelarPedido={onClickCancelarPedido}
          openDialogEnvioWhatsapp={openDialogEnvioWhatsapp}
          setOpenDialogEnvioWhatsapp={setOpenDialogEnvioWhatsapp}
        />
      }
      showUpdate={
        pedido.status === "ABERTO" ||
        permissoesHelper.temPermisao("pedidos-editar")
      }
      actionsTotalizadores={
        <ResumoTotal
          abaValue={abaValue}
          pedido={pedido}
          setPedido={setPedido}
          listaPedidosProdutos={listaPedidosProdutos}
          setListaPedidosProdutos={setListaPedidosProdutos}
          pedidoEntity={pedidoEntity}
        />
      }
      // formState={{
      //   inicial: prevStateRef?.current,
      //   final: montarObjetoPedidos(),
      // }}
    >
      <Grid container spacing={2}>
        <Grid item xs={4} md={1}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              id="serieDocumento"
              name="serieDocumento"
              label="Série"
              variant="filled"
              disabled
              value={pedido.serieDocumento ?? ""}
              fullWidth
            />
          </FormControl>
        </Grid>
        <Grid item xs={8} md={3}>
          <DatePicker
            id="dataEmissao"
            name="dataEmissao"
            label="Data de Emissão"
            format="dd/MM/yyyy"
            variant="filled"
            disabled
            value={new Date()}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="operacaoFiscalId"
              name="operacaoFiscalId"
              disabled={id && pedido.status !== "ABERTO"}
              required
              options={operacaoFiscalList}
              noOptionsText="Sem opções"
              autoHighlight
              disableClearable
              getOptionLabel={(option) =>
                option.descricao ? `${option.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Operação Fiscal"
                  variant="outlined"
                  error={inputErros.get("operacaoFiscalId")}
                  required
                />
              )}
              onChange={(e, newValue) =>
                handleChangeAutocomplete("operacaoFiscalId", newValue)
              }
              value={value.autoComplete(
                operacaoFiscalList,
                pedido?.operacaoFiscalId,
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-2">
        <Grid item xs={6} className="d-flex align-items-center">
          <Grid
            item
            xs={id || !pedido?.pessoaClienteId || !pedidos.length ? 28 : 14}
          >
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="pessoaClienteId"
                name="pessoaClienteId"
                disabled={id && pedido.status !== "ABERTO"}
                options={clienteList}
                autoHighlight
                getOptionLabel={(option) => {
                  if (option.nomeRazaoSocial) {
                    if (option.codigo) {
                      return `${option.codigo} - ${option.nomeRazaoSocial}`;
                    }
                    return option.nomeRazaoSocial;
                  }
                }}
                loading={loadingAutoCompleteCliente}
                loadingText="Carregando"
                noOptionsText={
                  document.getElementById("pessoaClienteId")?.value.length >=
                    1 && !id ? (
                    <Grid container spacing={1}>
                      <Grid item xs={12} fullWidth>
                        Nenhum cliente encontrado
                      </Grid>
                    </Grid>
                  ) : (
                    "Digite e pressione Enter"
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    variant="outlined"
                    onKeyDown={(e) => onSearchChangePessoas(e, 1)}
                    inputRef={inputCliente}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <React.Fragment>
                            {loadingAutoCompleteCliente ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        </>
                      ),
                    }}
                  />
                )}
                onChange={(e, newValue) =>
                  onChangeAutocompleteCliente(newValue)
                }
                value={clienteSelecionado}
              />
            </FormControl>
          </Grid>
          <Grid
            item
            xs={2}
            className="d-flex justify-content-end align-items-center gap-2"
          >
            <Tooltip title="Cadastrar Cliente" arrow placement="bottom">
              <Button
                id="buttonAdicionarCliente"
                variant="contained"
                disabled={id || !pedido?.operacaoFiscalId}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => setIsCadastroPessoaDialogOpen(true)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
            {!id && pedido?.pessoaClienteId && pedidos?.length ? (
              <>
                {loadingHistorico ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <Tooltip
                    title="Visualizar Histórico Cliente"
                    arrow
                    placement="bottom"
                  >
                    <Button
                      id="buttonHistoricoCliente"
                      variant="contained"
                      disabled={
                        !pedido?.operacaoFiscalId || !pedido?.pessoaClienteId
                      }
                      size="small"
                      sx={{
                        height: "35px",
                        borderRadius: "20%",
                        minWidth: "15px",
                        boxShadow: "none",
                      }}
                      onClick={() => {
                        setOpenHistoricoClienteDialog(true);
                      }}
                    >
                      <i
                        className="ph-fill ph-shopping-cart"
                        style={{ fontSize: 15, color: "white" }}
                      ></i>
                    </Button>
                  </Tooltip>
                )}
              </>
            ) : null}
          </Grid>
        </Grid>
        <Grid item xs={12} md={5.5}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="pessoaVendedorId"
              name="pessoaVendedorId"
              disabled={id && pedido.status !== "ABERTO"}
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              options={vendedorList}
              autoHighlight
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vendedor"
                  variant="outlined"
                  required={vendedorObrigatorio}
                  error={inputErros.get("pessoaVendedorId")}
                />
              )}
              onChange={(e, newValue) => {
                e.persist();
                setInputErro([]);
                handleChangeAutocomplete("pessoaVendedorId", newValue);
              }}
              value={value.autoComplete(vendedorList, pedido?.pessoaVendedorId)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0.5}>
          <IconButton
            variant="contained"
            size="small"
            className="mt-2"
            onClick={() =>
              setTiposTotalizadoresColumnView(!tiposTotalizadoresColumnView)
            }
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: tiposTotalizadoresColumnView ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
        {tiposTotalizadoresColumnView && (
          <Grid container spacing={2} className="mt-2">
            <Grid item xs={8}></Grid>
            <Grid item xs={2} className="d-flex justify-content-end">
              <FormControlLabel
                label="Desconto por Item"
                labelPlacement="end"
                control={
                  <Checkbox
                    name="descontoItem"
                    checked={pedido?.descontoItem ?? false}
                    onChange={handleChangeSwitch}
                    color="primary"
                  />
                }
              />
            </Grid>
            <Grid item xs={2} className="d-flex justify-content-end">
              <FormControlLabel
                label="Despesa por Item"
                labelPlacement="end"
                control={
                  <Checkbox
                    name="despesasItem"
                    checked={pedido?.despesasItem ?? false}
                    onChange={handleChangeSwitch}
                    color="primary"
                  />
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <hr className="mt-4 mb-2" />
      <Paper>
        <Tabs
          value={abaValue}
          onChange={(e, value) => {
            e.persist();
            setAbaValue(value);
          }}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          className="mt-3"
        >
          <Tab
            label="ITENS DA NOTA"
            {...tabProps(0)}
            disabled={
              !id && obrigatoriedadeMeioPagamento && !condicaoSelecionada
            }
          />
          <Tab
            label="PAGAMENTOS"
            {...tabProps(1)}
            disabled={
              !id &&
              !(obrigatoriedadeMeioPagamento || listaPedidosProdutos?.length)
            }
          />
          <Tab label="DADOS DO CLIENTE" {...tabProps(2)} />
          <Tab label="INFORMAÇÕES ADICIONAIS" {...tabProps(3)} />
        </Tabs>
      </Paper>
      <CardContent>
        <TabPanel value={abaValue} index={0}>
          <PedidosItens
            id={id}
            pedido={pedido}
            setPedido={setPedido}
            setLoadingAutoCompleteProduto={setLoadingAutoCompleteProduto}
            loadingAutoCompleteProduto={loadingAutoCompleteProduto}
            setLoading={setLoading}
            produtoList={produtoList}
            setProdutoList={setProdutoList}
            produto={produto}
            setProduto={setProduto}
            calcularValorTotal={calcularValorTotal}
            listaPedidosProdutos={listaPedidosProdutos}
            setListaPedidosProdutos={setListaPedidosProdutos}
            setListaPedidosPagamentos={setListaPedidosPagamentos}
            tabelas={tabelas}
            buscarProdutosSimilares={buscarProdutosSimilares}
            produtosSimilares={produtosSimilares}
            setProdutosSimilares={setProdutosSimilares}
            removerProdutoCadastrado={removerProdutoCadastrado}
            permitirVendaEstoqueNegativo={permitirVendaEstoqueNegativo}
            origensMercadoriasList={origensMercadoriasList}
            listaUnidadesComerciais={listaUnidadesComerciais}
            setListaUnidadesComerciais={setListaUnidadesComerciais}
            pedidoEntity={pedidoEntity}
            meioPagamentoSelecionado={meioPagamentoSelecionado}
            acrescimoPagamento={acrescimoPagamento}
            tabelasTodosProdutos={tabelasTodosProdutos}
            enderecosEstoqueList={enderecosEstoqueList}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={1}>
          <PedidosPagamentos
            id={id}
            pedido={pedido}
            setPedido={setPedido}
            listaPedidosPagamentos={listaPedidosPagamentos}
            setListaPedidosPagamentos={setListaPedidosPagamentos}
            condicaoPagamentoList={condicaoPagamentoList}
            gerarPagamentos={gerarPagamentos}
            setGerarPagamentos={setGerarPagamentos}
            condicaoPagParcelaList={condicaoPagParcelaList}
            setCondicaoPagParcelaList={setCondicaoPagParcelaList}
            meioPagamentoList={meioPagamentoList}
            meiosPagamentoCliente={meiosPagamentoCliente}
            pedidoEntity={pedidoEntity}
            meioPagamentoSelecionado={meioPagamentoSelecionado}
            setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
            condicaoSelecionada={condicaoSelecionada}
            setCondicaoSelecionada={setCondicaoSelecionada}
            setAbaValue={setAbaValue}
            obrigatoriedadeMeioPagamento={obrigatoriedadeMeioPagamento}
            listaPedidosProdutos={listaPedidosProdutos}
            setListaPedidosProdutos={setListaPedidosProdutos}
            setAcrescimoPagamento={setAcrescimoPagamento}
            produto={produto}
            setProduto={setProduto}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={2}>
          {abaValue == 2 ? (
            <PedidosDadosClientes
              id={id}
              pedido={pedido}
              setPedido={setPedido}
              enderecoAleterado={enderecoAleterado}
              setEnderecoAleterado={setEnderecoAleterado}
              clienteList={clienteList}
              enderecoCliente={enderecoCliente}
              buscarDadosClientes={buscarDadosClientes}
              enderecoClienteDataGrid={enderecoClienteDataGrid}
              clienteSelecionado={clienteSelecionado}
              cidadeId={cidadeId}
              setCidadeId={setCidadeId}
              endereco={endereco}
              setEndereco={setEndereco}
              salvarEndereco={salvarEndereco}
              inputErros={inputErros}
              pedidoEntity={pedidoEntity}
            />
          ) : null}
        </TabPanel>
        <TabPanel value={abaValue} index={3}>
          <PedidosCampos
            pedido={pedido}
            handleChangeInput={handleChangeInput}
          />
        </TabPanel>
        <FullscreenDialog
          open={isCadastroPessoaDialogOpen}
          handleClose={handleCloseCadastroCliente}
          content={
            <AddPessoas
              match={{ params: { id: null } }}
              isFullscreenDialog
              onChangeCliente={onChangeAutocompleteCliente}
              handleCloseFullscreenDialog={handleCloseCadastroCliente}
            />
          }
        />
        <HistorioClienteDialog
          open={openHistoricoClienteDialog}
          setOpen={setOpenHistoricoClienteDialog}
          clienteId={pedido?.pessoaClienteId}
          pedidos={pedidos}
          setPedidos={setPedidos}
          totalItems={totalItems}
          setTotalItems={setTotalItems}
        />
      </CardContent>
      <ComissaoVendedorDialog
        openComissaoDialog={openComissaoDialog}
        setOpenComissaoDialog={setOpenComissaoDialog}
        itemValorComissaoVendedor={itemValorComissaoVendedor}
        setItemValorComissaoVendedor={setItemValorComissaoVendedor}
        itemPercentualComissaoVendedor={itemPercentualComissaoVendedor}
        setItemPercentualComissaoVendedor={setItemPercentualComissaoVendedor}
        itemTotalComissaoVendedor={itemTotalComissaoVendedor}
        setItemTotalComissaoVendedor={setItemTotalComissaoVendedor}
        listaPedidosProdutos={listaPedidosProdutos}
      />
      <CampoPersonalizadoDialog
        openCampoPersonalizadoDialog={openCampoPersonalizadoDialog}
        setOpenCampoPersonalizadoDialog={setOpenCampoPersonalizadoDialog}
        onInputChangeCamposPersonalizados={onInputChangeCamposPersonalizados}
        handleAdicionarCampoPersonalizado={handleAdicionarCampoPersonalizado}
        campoPersonalizado={campoPersonalizado}
        setCampoPersonalizado={setCampoPersonalizado}
        tiposCampo={tiposCampo}
      />
    </AddLayout>
  );
};

export default AddPedidosView;
